import React, { ReactNode } from 'react';

interface Props {
    title: string;
    /** Shown next to the title, as the mockup's counters do. */
    counter?: number;
    /** Buttons of the section header: « Modifier », « Supprimer ». */
    actions?: ReactNode;
    children: ReactNode;
}

/**
 * The card of the back-office screens: a heading, an optional counter and actions,
 * a body.
 *
 * It stays in the application rather than in `@freelancelabs/components`: it is
 * three divs and the mockup's border radius, and the design system fills up fast
 * with shapes that turn out to be one screen's habit. It moves there the day a
 * second application needs the same card.
 */
const Card = ({ title, counter, actions, children }: Props) => (
    <section className="rounded-lg border border-border-norm bg-background-norm">
        <header className="flex flex-wrap items-center gap-3 border-b border-border-norm px-4 py-3">
            <h2 className="text-base font-semibold text-text-900">{title}</h2>
            {/* Counter and actions both to the right, as the mockup places them: the
                title keeps the left edge whatever the section carries. */}
            {typeof counter === 'number' && (
                <span className="ml-auto rounded-full border border-border-norm bg-background-weak px-2 py-0.5 font-mono text-xs text-text-600">
                    {counter}
                </span>
            )}
            {actions && (
                <div className={`flex items-center gap-2 ${typeof counter === 'number' ? '' : 'ml-auto'}`}>
                    {actions}
                </div>
            )}
        </header>
        <div className="px-4 py-4">{children}</div>
    </section>
);

export default Card;
